import React from 'react';
import Card from '../Card/Card';
import PropTypes from 'prop-types';
import './CardWithColoredHeader.scss';

//Componente a Deprecar mover a Card
const CardWithColoredHeader = ({ body }) => {
  return <Card>{body}</Card>;
};

CardWithColoredHeader.propTypes = {
  body: PropTypes.string,
};

export default CardWithColoredHeader;
